import { PortfolioService, PortfolioServiceTag } from '@acp/shared';
import {
    Box,
    Button,
    Tooltip,
    useToken,
} from '@chakra-ui/react';
import { ServiceIcon } from '@acp/core-ui';
import { forwardRef } from 'react';

function isServiceIssue(service: PortfolioService, _allServices: PortfolioService[]) {
    return service.tags.includes(PortfolioServiceTag.HasUrgentQuotations);
}

function PropertyServiceRefFunction({
    service,
    tooltip,
    showTooltip = false,
    isError = false,
    ...rest
}: {
    service: {
        shortName: string;
        tags: string[];
    };
    tooltip?: string;
    showTooltip?: boolean;
    isError?: boolean;
}, ref: React.ForwardedRef<HTMLInputElement>) {
    const accent = useToken('colors', isError ? 'danger.500' : 'muted.50');
    const serviceIconColor = useToken('colors', isError ? 'danger.500' : 'primary.500');
    const bgColor = useToken('colors', isError ? 'danger.50' : 'white');

    return (
        <Tooltip label={tooltip} isDisabled={!showTooltip}>
            <Button
                ref={ref}
                as={Box}
                aria-label="Service Icon Button"
                key={service.shortName}
                size="md"
                px={1}
                color="charcoal.900"
                fontWeight="normal"
                variant="outline"
                colorScheme="muted"
                borderColor={accent}
                bgColor={bgColor}
                _hover={{ backgroundColor: bgColor }}
                iconSpacing={0}
                leftIcon={(
                    <ServiceIcon
                        height="22px"
                        service={service.shortName}
                        fill={serviceIconColor}
                    />
                )}
                {...rest}
            />
        </Tooltip>

    );
}

const PropertyService = forwardRef(PropertyServiceRefFunction);

export { PropertyService, isServiceIssue };
